import i18n from '@/i18n';

export const DISTRIBUTOR_STEP_1 = 0;
export const DISTRIBUTOR_STEP_2 = 1;
export const DISTRIBUTOR_STEP_3 = 2;

const steps = {
  [DISTRIBUTOR_STEP_1]: {
    component: () => import(/* webpackChunkName: "common" */ '@/views/common/distributors/new-distributor/Info.vue'),
    title: 'Create Supplier - Info',
    pageTitle: 'Please add main info',
    pageInfo: `Add ${i18n.t('global.distributor').toLowerCase()}’s logo, it’s name, contact info and addresses of the business that will be used throughout the platform.`,
    nextCta: 'Next Step',
  },
  [DISTRIBUTOR_STEP_2]: {
    component: () => import(/* webpackChunkName: "common" */ '@/views/common/distributors/new-distributor/Users.vue'),
    title: 'Create Supplier - Users',
    pageTitle: 'Users',
    pageInfo: `You are automatically assigned to this ${i18n.t('global.distributor').toLowerCase()} with the Admin role.`,
    nextCta: 'Go to Overview',
  },
  [DISTRIBUTOR_STEP_3]: {
    component: () => import(/* webpackChunkName: "common" */ '@/views/common/distributors/new-distributor/Overview.vue'),
    title: 'Create Supplier - Overview',
    pageTitle: 'Overview',
    pageInfo: `Before you complete adding a new ${i18n.t('global.distributor').toLowerCase()}, check the information below to make sure you’ve entered everything correctly.`,
    nextCta: 'Finish',
  },
};

export default steps;
